import script from "./learn.vue?vue&type=script&setup=true&lang=js"
export * from "./learn.vue?vue&type=script&setup=true&lang=js"

import "./learn.vue?vue&type=style&index=0&id=7dbad409&scoped=true&lang=css"

import exportComponent from "F:\\work\\FFSTAR3\\VUESP\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dbad409"]])

export default __exports__